export const SEX_ITEMS = [
  { text: "男", value: 1 },
  { text: "女", value: 2 },
  { text: "その他", value: 3 }
];
